import { FC, Fragment, useEffect } from 'react'
import { Tiny2 } from '@/components/atoms/typography'
import { Flex } from '@/components/atoms/Grid'
import styled from 'styled-components'
import Link from '@/components/atoms/link'
import { SlugPathItem } from 'types/slugPath'
import { useMainNavigationDispatch } from '@/providers/mainNavigationMenuProvider'

type CategoryPathHeaderRedesignProps = {
  paths: SlugPathItem[]
} & Rest

const CategoryPathHeaderRedesign: FC<CategoryPathHeaderRedesignProps> = ({
  paths,
  ...rest
}) => {
  const { updateSlugPath } = useMainNavigationDispatch()

  useEffect(() => {
    updateSlugPath(paths)
    return () => {
      updateSlugPath([])
    }
  }, [paths])

  return (
    <>
      {paths?.length > 0 && (
        <Wrapper
          flexWrap="wrap"
          alignItems="center"
          {...rest}
          data-testid="categoryPathHeader"
        >
          {paths
            .filter((item) => item)
            .map(({ url, title }, offset) => (
              <Fragment key={url + title}>
                <Link href={url}>
                  <PathItem key={url}>{title} </PathItem>
                </Link>
                {offset + 1 < paths.length && <Delimiter />}
              </Fragment>
            ))}
        </Wrapper>
      )}
    </>
  )
}

export default CategoryPathHeaderRedesign

const Delimiter: FC = () => (
  <Tiny2 m={0} px={2}>
    &gt;
  </Tiny2>
)

const Wrapper = styled(Flex)`
  padding: 32px 0 12px 0;
`

const PathItem = styled(Tiny2)`
  margin: 0;
  flex-direction: row;
  font-weight: 400;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`
